import { createReducer } from "redux-create-reducer";

import {
  GET_SINGLE_CLIENT_REPORT_DETAILS,
  SET_COLLAPSE_ALL_SINGLE_CLIENT_REPORT_DETAILS,
  SET_EXPANDED_ROWS_LINKED_CLIENTS_SINGLE_CLIENT_REPORT,
  SET_TOGGLE_COLLAPSES_CLOSED_SINGLE_CLIENT_REPORT_DETAILS,
} from "../../types";

const initialState = {
  data: [],
  isLoading: false,
  collapsesClosed: false,
  expandedRowsLinkedClients: [],
};

const singleClientReportDetailsReducer = createReducer(initialState, {
  [GET_SINGLE_CLIENT_REPORT_DETAILS.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_SINGLE_CLIENT_REPORT_DETAILS.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_SINGLE_CLIENT_REPORT_DETAILS.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_SINGLE_CLIENT_REPORT_DETAILS.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: payload.data,
    isLoading: false,
  }),
  [SET_TOGGLE_COLLAPSES_CLOSED_SINGLE_CLIENT_REPORT_DETAILS]: (state) => ({
    ...state,
    collapsesClosed: !state.collapsesClosed,
  }),
  [SET_COLLAPSE_ALL_SINGLE_CLIENT_REPORT_DETAILS]: (state) => ({
    ...state,
    collapsesClosed: false,
    expandedRowsLinkedClients: [],
  }),
  [SET_EXPANDED_ROWS_LINKED_CLIENTS_SINGLE_CLIENT_REPORT]: (
    state,
    { payload }
  ) => ({
    ...state,
    expandedRowsLinkedClients: payload,
  }),
});

export default singleClientReportDetailsReducer;



// WEBPACK FOOTER //
// ./src/features/reports/reducers/single-client/singleClientReportDetailsReducer.js